import React, { Component } from 'react';
import { connect } from 'react-redux';

import CreateIntegrationDashboard from './CreateIntegrationDashboard';
import CreateFileDashboard from './CreateFileDashboard';
import AutoConfigDashboard from './AutoConfigDashboard';
import AkbDashboard from './AkbDashboard';
import { isTrelloAddon, isJiraPlugin } from '../../util/addons';

class CreateDashboard extends Component {
  renderFileDashboard = (props) => {
    return <CreateFileDashboard {...props} />;
  };

  renderIntegrationDashboard = (props) => {
    return <CreateIntegrationDashboard {...props} />;
  };

  renderAutoConfigDashboard = (props) => {
    return <AutoConfigDashboard {...props} />;
  }

  renderAkbDashboard = (props) => {
    return <AkbDashboard {...props} />;
  }

  render() {
    if (
      (!this.props.dashboards || this.props.dashboards.length === 0) && 
      (this.props.user && this.props.user.dashboards === 0) && (
        isTrelloAddon(this.props.location) ||
        isJiraPlugin(this.props.location)
      )
    ) {
      return this.renderAutoConfigDashboard(this.props);
    }
    if (this.props.outside && !!this.props.plugin && this.props.plugin.aid) {
      return this.renderAkbDashboard(this.props);
    }
    if (
      this.props.dashboardModel &&
      this.props.dashboardModel.akbBoardId &&
      this.props.dashboardModel.akbBoardId !== 'false'
    ) {
      return this.renderAkbDashboard(this.props);
    }
    if (this.props.app === 'file') {
      return this.renderFileDashboard(this.props);
    } else {
      return this.renderIntegrationDashboard(this.props);
    }
  }
}

function mapStateToProps(state) {
  return {
    app: state.app.app,
    dashboardModel: state.dashboards.dashboardModel,
    outside: state.app.outside,
    plugin: state.app.plugin,
    akb: state.dashboards.akb,
  };
}

export default connect(mapStateToProps)(CreateDashboard);
